import { render, staticRenderFns } from "./PurchaseOverlay.vue?vue&type=template&id=cb78c706&"
import script from "./PurchaseOverlay.vue?vue&type=script&lang=js&"
export * from "./PurchaseOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports